export default {
  INTEGRATIONS: {
    INDEX: {
      TITLE: {
        LABEL: "Gerencie suas Integrações",
      },

      SUBTITLE: {
        LABEL:
          "Monitore e adicione integrações para melhor os dados do seu negócio.",
      },

      SUBHEADER: {
        SEARCH: {
          LABEL: "Filtrar",
          PLACEHOLDER: "Pesquisar integração instalada",
        },

        NEW_INTEGRATION: {
          LABEL: "Adicionar integração",
        },
      },
    },
  },
};
